import { useEffect } from 'react';

/**
 * 히어로 메시 모션 — 화면 밖이면 일시정지 (배터리/GPU 절약).
 * `.is-paused` 가 자신과 자손의 animation-play-state 를 멈춘다.
 */
export function useHeroDrift(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-paused', !entry.isIntersecting);
        });
      },
      { threshold: 0 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
}
